// frontend/src/pages/club/ClubMatches/ClubMatches.jsx
import React, { useEffect, useState, useCallback } from 'react';
import Input from '../../../components/common/Input';
import ExportButton from '../../../components/common/ExportButton';
import Pagination from '../../../components/common/Pagination';
import { getMatchesApi, exportMatchesApi } from '../../../api/match.api';
import MatchesTable from '../../../components/tables/MatchesTable';
import { MATCH_STATUS_LABELS, MATCH_TYPE_LABELS } from '../../../utils/constants';

export default function ClubMatches() {
  const [matches, setMatches] = useState([]);
  const [filters, setFilters] = useState({ status: '', type: '', search: '' });
  const [pagination, setPagination] = useState({ page: 1, limit: 10, total: 0, totalPages: 1 });
  const [snackbar, setSnackbar] = useState('');
  const [loading, setLoading] = useState(false);

  const loadMatches = useCallback(async () => {
    setLoading(true);
    try {
      const clean = Object.fromEntries(Object.entries(filters).filter(([, v]) => v !== ''));
      const { data } = await getMatchesApi({ ...clean, page: pagination.page, limit: pagination.limit });
      setMatches(data.data);
      setPagination(prev => ({ ...prev, total: data.meta.total, totalPages: data.meta.totalPages }));
    } catch (err) {
      setSnackbar(err.response?.data?.message || 'خطا در دریافت مسابقات');
    } finally {
      setLoading(false);
    }
  }, [filters, pagination.page, pagination.limit]);

  useEffect(() => { loadMatches(); }, [loadMatches]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setPagination(prev => ({ ...prev, page: newPage }));
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold">مسابقات باشگاه</h1>
        <ExportButton fileName="matches.xlsx" onExport={() => exportMatchesApi({})} />
      </div>

      <div className="flex flex-wrap gap-3">
        <select
          className="rounded-xl border border-slate-200 p-2 text-sm outline-none focus:ring-2 focus:ring-emerald-500/30"
          value={filters.status}
          onChange={(e) => setFilters({ ...filters, status: e.target.value })}
        >
          <option value="">همه وضعیت‌ها</option>
          {Object.entries(MATCH_STATUS_LABELS).map(([k, v]) => (
            <option key={k} value={k}>{v}</option>
          ))}
        </select>
        <select
          className="rounded-xl border border-slate-200 p-2 text-sm outline-none focus:ring-2 focus:ring-emerald-500/30"
          value={filters.type}
          onChange={(e) => setFilters({ ...filters, type: e.target.value })}
        >
          <option value="">همه انواع</option>
          {Object.entries(MATCH_TYPE_LABELS).map(([k, v]) => (
            <option key={k} value={k}>{v}</option>
          ))}
        </select>
        <Input
          placeholder="جستجو..."
          value={filters.search}
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
          className="h-11 w-64"
        />
      </div>

      {snackbar && (
        <div className="rounded-xl bg-emerald-50 p-3 text-sm text-emerald-700">
          {snackbar}
          <button className="mr-2" onClick={() => setSnackbar('')}>✕</button>
        </div>
      )}

      <div className="rounded-2xl border border-slate-200 bg-white p-4 overflow-x-auto">
        {loading ? (
          <div className="py-8 text-center text-text-dark/50">در حال بارگذاری...</div>
        ) : (
          <>
            <MatchesTable
              matches={matches}
              canManage={false}   // مدیر باشگاه نمی‌تواند نتیجه ثبت یا لغو کند
            />
            <Pagination
              page={pagination.page}
              totalPages={pagination.totalPages}
              onPageChange={handlePageChange}
            />
          </>
        )}
      </div>
    </div>
  );
}